export default "__VITE_ASSET__CC87ehVf__"